var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createI18n } from 'vue-i18n';
import { getLang as getCurrentLang, setLangCookie } from './tools';
import { renderSlot, createElementBlock, Fragment, createCommentVNode } from 'vue';
export * from './types';
var i18n = null;
/**
 * 获取多语言转换函数
 * @returns
 */
var getT = function () {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (i18n && i18n.global && i18n.global.t) {
        return i18n.global.t;
    }
    throw new Error('i18n.global.t is nonexistent');
};
/**
 * 获取多语言复数转换函数
 * @returns
 */
var getTc = function () {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (i18n && i18n.global && i18n.global.tc) {
        return i18n.global.tc;
    }
    throw new Error('i18n.global.tc is nonexistent');
};
/**
 * 切换语言
 * @param lang
 */
var setLang = function (lang) {
    if (!i18n) {
        throw new Error('请先执行initI18n初始化');
    }
    setLangCookie(lang);
    // 当前语言
    i18n.global.locale = lang;
};
/**
 * 获取当前语言
 * @returns
 */
var getLang = function () {
    if (!i18n) {
        throw new Error('请先执行initI18n初始化');
    }
    return i18n.global.locale;
};
/**
 * 初始化
 * @param langConfigs 多语言词组
 * @param defaultLang 兜底语言
 */
var init = function (langConfigs, defaultLang) {
    if (defaultLang === void 0) { defaultLang = 'zh-HK'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var lang_1, oneLang, key, lang, installMethod;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // 如果scan后的某个key是空字符串, 直接等同key(否则当前vue-i18n会直接返回空字符串, 不能直接delete key, 否则key里有模板变量会无法格式化)
                    // eslint-disable-next-line
                    for (lang_1 in langConfigs) {
                        oneLang = langConfigs[lang_1];
                        // eslint-disable-next-line
                        for (key in oneLang) {
                            if (oneLang[key] === '') {
                                oneLang[key] = key;
                            }
                        }
                    }
                    return [4 /*yield*/, getCurrentLang(defaultLang)];
                case 1:
                    lang = _a.sent();
                    setLangCookie(lang);
                    i18n = createI18n({
                        // 设置默认语言
                        locale: lang,
                        messages: langConfigs,
                    });
                    installMethod = i18n.install;
                    i18n.install = function (app) {
                        // 注册全局组件
                        app.component('language-vue', {
                            // @ts-ignore
                            render: function (_a) {
                                var $slots = _a.$slots;
                                var lang = getLang();
                                var isEng = lang === 'en-GB';
                                var children = [
                                    !isEng ? renderSlot($slots, 'default', { key: 0 }) : createCommentVNode('v-if', true),
                                    isEng ? renderSlot($slots, 'en', { key: 1 }) : createCommentVNode('v-if', true),
                                ];
                                return createElementBlock(Fragment, null, children);
                            },
                        });
                        // 给body 标签添加lang作为className
                        var bodyClassName = document.getElementsByTagName('body')[0].className;
                        bodyClassName += bodyClassName ? " ".concat(lang) : lang;
                        document.getElementsByTagName('body')[0].className = bodyClassName;
                        // 执行原先的install方法
                        installMethod(app);
                    };
                    return [2 /*return*/, i18n];
            }
        });
    });
};
var i18nObj = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    getT: getT,
    getTc: getTc,
};
export { i18nObj as i18n, getCurrentLang as getLang };
